export interface City {
  label: string;
  name: string;
}

export const cities: City[] = [
  {
    label: '上海',
    name: 'SHANGHAI',
  },
  {
    label: '東莞',
    name: 'DONGGUAN',
  },
  {
    label: '広州',
    name: 'GUANGZHOU',
  },
  {
    label: '厦门',
    name: 'XIAMEN',
  },
  {
    label: '大連',
    name: 'DALIAN',
  },
  {
    label: '天津',
    name: 'TIANJIN',
  },
  {
    label: '深圳',
    name: 'SHENZHEN',
  },
  {
    label: '青島',
    name: 'QINGDAO',
  },
  {
    label: '石島',
    name: 'SHIDAO',
  },
  {
    label: '広東',
    name: 'GUANGDONG',
  },
  {
    label: '蛇口',
    name: 'SHEKOU',
  },
  {
    label: '博多',
    name: 'HAKATA',
  },
  {
    label: '名古屋',
    name: 'NAGOYA',
  },
  {
    label: '大阪',
    name: 'OSAKA',
  },
  {
    label: '東京',
    name: 'TOKYO',
  },
  {
    label: '関西',
    name: 'KANSAI',
  },
];

// Without Haishang Suda
// export const receivingCityNames = ['SHANGHAI', 'GUANGDONG', 'SHENZHEN'];

// With Haishang Suda
// export const receivingCityNames = [
//   'SHANGHAI',
//   'GUANGDONG',
//   'XIAMEN',
//   'DALIAN',
//   'TIANJIN',
//   'QINGDAO',
// ];

export const warehouseCityNames = [
  'SHANGHAI',
  'GUANGDONG',
  'SHIDAO',
  'XIAMEN',
  'DALIAN',
  'TIANJIN',
  'QINGDAO',
  'SHENZHEN',
];

export const polCityNames = ['SHANGHAI', 'SHIDAO', 'SHEKOU', 'QINGDAO'];

export const podCityNames = ['TOKYO', 'OSAKA', 'NAGOYA', 'HAKATA', 'KANSAI'];

export const getCityLabelByName = (name: string, or?: string) =>
  cities.find((c) => c.name === name)?.label ?? or ?? name;

export interface ReceivingCityOption {
  name: string;
  label: string;
  displayCities: string[];
}

export const receivingCityOptions: ReceivingCityOption[] = [
  {
    name: 'SHANGHAI',
    label: '上海倉庫',
    displayCities: ['SHANGHAI'],
  },
  {
    name: 'GUANGDONG',
    label: '広東倉庫',
    displayCities: ['SHENZHEN', 'GUANGZHOU', 'DONGGUAN'],
  },
  {
    name: 'QINGDAO',
    label: '青島倉庫',
    displayCities: ['QINGDAO'],
  },
];

export const getReceivingCityOptionInlineDisplay = (group: ReceivingCityOption) => {
  if (group.displayCities.length === 1) {
    return `${group.label} ${group.displayCities[0]}`;
  } else {
    return `${group.label} （${group.displayCities.join('・')}）`;
  }
};

export interface JapanPrefecture {
  pref: string;
  pref_rome: string;
}

/**
 * Results from FC API: /fc/pref-and-city
 */
export const japanPrefectures: JapanPrefecture[] = [
  {
    pref: '北海道',
    pref_rome: 'HOKKAIDO',
  },
  {
    pref: '青森県',
    pref_rome: 'AOMORI KEN',
  },
  {
    pref: '岩手県',
    pref_rome: 'IWATE KEN',
  },
  {
    pref: '宮城県',
    pref_rome: 'MIYAGI KEN',
  },
  {
    pref: '秋田県',
    pref_rome: 'AKITA KEN',
  },
  {
    pref: '山形県',
    pref_rome: 'YAMAGATA KEN',
  },
  {
    pref: '福島県',
    pref_rome: 'FUKUSHIMA KEN',
  },
  {
    pref: '茨城県',
    pref_rome: 'IBARAKI KEN',
  },
  {
    pref: '栃木県',
    pref_rome: 'TOCHIGI KEN',
  },
  {
    pref: '群馬県',
    pref_rome: 'GUMMA KEN',
  },
  {
    pref: '埼玉県',
    pref_rome: 'SAITAMA KEN',
  },
  {
    pref: '千葉県',
    pref_rome: 'CHIBA KEN',
  },
  {
    pref: '東京都',
    pref_rome: 'TOKYO TO',
  },
  {
    pref: '神奈川県',
    pref_rome: 'KANAGAWA KEN',
  },
  {
    pref: '新潟県',
    pref_rome: 'NIIGATA KEN',
  },
  {
    pref: '富山県',
    pref_rome: 'TOYAMA KEN',
  },
  {
    pref: '石川県',
    pref_rome: 'ISHIKAWA KEN',
  },
  {
    pref: '福井県',
    pref_rome: 'FUKUI KEN',
  },
  {
    pref: '山梨県',
    pref_rome: 'YAMANASHI KEN',
  },
  {
    pref: '長野県',
    pref_rome: 'NAGANO KEN',
  },
  {
    pref: '岐阜県',
    pref_rome: 'GIFU KEN',
  },
  {
    pref: '静岡県',
    pref_rome: 'SHIZUOKA KEN',
  },
  {
    pref: '愛知県',
    pref_rome: 'AICHI KEN',
  },
  {
    pref: '三重県',
    pref_rome: 'MIE KEN',
  },
  {
    pref: '滋賀県',
    pref_rome: 'SHIGA KEN',
  },
  {
    pref: '京都府',
    pref_rome: 'KYOTO FU',
  },
  {
    pref: '大阪府',
    pref_rome: 'OSAKA FU',
  },
  {
    pref: '兵庫県',
    pref_rome: 'HYOGO KEN',
  },
  {
    pref: '奈良県',
    pref_rome: 'NARA KEN',
  },
  {
    pref: '和歌山県',
    pref_rome: 'WAKAYAMA KEN',
  },
  {
    pref: '鳥取県',
    pref_rome: 'TOTTORI KEN',
  },
  {
    pref: '島根県',
    pref_rome: 'SHIMANE KEN',
  },
  {
    pref: '岡山県',
    pref_rome: 'OKAYAMA KEN',
  },
  {
    pref: '広島県',
    pref_rome: 'HIROSHIMA KEN',
  },
  {
    pref: '山口県',
    pref_rome: 'YAMAGUCHI KEN',
  },
  {
    pref: '徳島県',
    pref_rome: 'TOKUSHIMA KEN',
  },
  {
    pref: '香川県',
    pref_rome: 'KAGAWA KEN',
  },
  {
    pref: '愛媛県',
    pref_rome: 'EHIME KEN',
  },
  {
    pref: '高知県',
    pref_rome: 'KOCHI KEN',
  },
  {
    pref: '福岡県',
    pref_rome: 'FUKUOKA KEN',
  },
  {
    pref: '佐賀県',
    pref_rome: 'SAGA KEN',
  },
  {
    pref: '長崎県',
    pref_rome: 'NAGASAKI KEN',
  },
  {
    pref: '熊本県',
    pref_rome: 'KUMAMOTO KEN',
  },
  {
    pref: '大分県',
    pref_rome: 'OITA KEN',
  },
  {
    pref: '宮崎県',
    pref_rome: 'MIYAZAKI KEN',
  },
  {
    pref: '鹿児島県',
    pref_rome: 'KAGOSHIMA KEN',
  },
  {
    pref: '沖縄県',
    pref_rome: 'OKINAWA KEN',
  },
];
